<div class="breadcrumb-area">
	<h1>Editor de formato de facturas</h1>
</div>
<div class="card">
	<div class="card-header">
		<p class="h3">Visor</p>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col">
				<div class="row">
					<div class="col">
						<div class="form-group">
							<label for="warehouse-input" class="form-label">Bodega</label>
							<div class="input-group">
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.warehouse"
									[placeholder]="'Ingresa o crea una bodega'" [filterElements]="filterWarehouses"
									[typeElements]="'warehouse'" (changeMethod)="verifiedInput($event.event)"
									(inputMethod)="handleInput($event.event)"
									(getTitle)="$event.filterElement.title = $event.filterElement.name"
									(changeStatus)="changeStatusInput($event.filterElement)"></app-input-autocomplete>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-8">
						<span class="title-hr">
							<hr />Colores
							<hr />
						</span>
						<div class="row">
							<div class="col-sm form-group">
								<label for="header" class="form-label">Primario</label>
								<input type="color" class="form-control form-control-color" id="header" value="#563d7c"
									title="Choose your color" [(ngModel)]="fcolor"
									(change)="changeColor('primary'); previewTemplate();">
							</div>
							<div class="col-sm form-group">
								<label for="color-alternate-1" class="form-label">Secundario</label>
								<input type="color" class="form-control form-control-color" id="color-alternate-1"
									value="#563d7c" title="Choose your color" [(ngModel)]="scolor"
									(change)="changeColor('secondary'); previewTemplate();">
							</div>
							<div class="col-sm form-group">
								<label for="color-alternate-2" class="form-label">Terciario</label>
								<input type="color" class="form-control form-control-color" id="color-alternate-2"
									value="#563d7c" title="Choose your color" [(ngModel)]="tcolor"
									(change)="changeColor('tertiary'); previewTemplate();">
							</div>
						</div>
					</div>
					<div class="col-sm-4">
						<span class="title-hr">
							<hr />Logo
							<hr />
						</span>
						<div style="display: flex;justify-content: center;">
							<img src='../../../../../assets/img/logo-example.png' id="image-company" height="50px"
								width="50px" name="image-company" class="image-company" alt="">
						</div>
					</div>
				</div>
				<span class="title-hr">
					<hr />Datos por defecto
					<hr />
				</span>
				<div class="row">
					<div class="col form-group">
						<label for="numberItems" class="form-label">No. Items</label>
						<input type="number" [(ngModel)]="itemsPreview" (change)="previewTemplate();" id="numberItems" name="numberItems"
							class="form-control">
					</div>
					<div class="col form-group">
						<label for="type" class="form-label">Tipo:</label>
						<select name="type" id="type" [(ngModel)]="type" (change)="previewTemplate()" class="form-select">
							<option [ngValue]="types.NORMAL">NORMAL</option>
							<option [ngValue]="types.INVENTORY">INVENTARIO</option>
							<option [ngValue]="types.PROVIDER">PROVEEDOR</option>
							<option [ngValue]="types.QUOTATION">COTIZACION</option>
							<option [ngValue]="types.TRANSFER">TRANSFERENCIA</option>
						</select>
					</div>
				</div>
				<span class="title-hr">
					<hr />Plantillas
					<hr />
				</span>
				<div class="template-container mt-3 mb-3" [hidden]="!isLoaded">
					<div class="template" id="template1-container" (click)="selectTemplate(1)">
						<i *ngIf="!loadingPreview[1]" class="fa fa-circle-check primary-color"
							[class.selected]="template==1"></i>
						<span *ngIf="loadingPreview[1]" class="selected spinner-border spinner-border-sm"></span>
					</div>
					<div class="template" (click)="selectTemplate(2)">
						<svg width="8.5in" height="11in" viewBox="0 0 215.9 279.4" version="1.1" id="svg5"
							inkscape:version="1.1.2 (b8e25be833, 2022-02-05)" sodipodi:docname="template2.svg"
							xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
							xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
							xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
							<defs id="defs2">
								<linearGradient id="linearGradient19686" inkscape:swatch="solid">
									<stop style="stop-color:#4c4c4c;stop-opacity:1;" offset="0" id="stop19684" />
								</linearGradient>
							</defs>
							<g inkscape:groupmode="layer" id="layer2" inkscape:label="Capa 2"
								style="display:inline;mix-blend-mode:normal">
								<rect
									style="display:inline;opacity:0.190476;fill:#f6b73f;fill-opacity:1;fill-rule:evenodd;stroke-width:4.99999;stroke-linecap:round;stroke-linejoin:round;paint-order:stroke fill markers"
									id="rect859-8" width="220.70302" height="11.165419" x="-0.93045646" y="95.464294"
									ry="0" class="primary-color" />
								<rect style="fill:#f6b73f;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect22548" width="220.70302" height="11.165421" x="-0.9304564" y="95.464294"
									class="primary-color" />
								<rect
									style="display:inline;mix-blend-mode:normal;fill:#fef7e9;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect22548-4" width="220.70302" height="11.165421" x="-0.55827636" y="118.35339"
									class="secondary-color" />
								<rect
									style="display:inline;mix-blend-mode:normal;fill:#fef7e9;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect22548-4-6" width="220.70302" height="11.165421" x="-1.7735959" y="139.19548"
									class="secondary-color" />
								<rect
									style="display:inline;mix-blend-mode:normal;fill:#fef7e9;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect22548-4-6-1" width="220.70302" height="11.165421" x="-0.18609598"
									class="secondary-color" y="160.03758" />
								<rect
									style="display:inline;mix-blend-mode:normal;fill:#fef7e9;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect22548-4-6-1-3" width="220.70302" height="11.165421" x="-0.18609627"
									class="secondary-color" y="181.99625" />
								<rect style="fill:#f6b73f;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									class="primary-color" id="rect24171" width="218.59317" height="27.680737" x="0"
									y="255.3158" />
								<rect
									style="fill:#d14894;fill-opacity:1;fill-rule:evenodd;stroke:#f6b73f;stroke-width:0.4;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
									id="rect27390" width="55.454887" height="9.6766911" x="149.24435" y="218.09775"
									rx="4" class="tertiary-color primary-color-circle" ry="4" />
								<rect
									style="fill:none;fill-rule:evenodd;stroke:#f6b73f;stroke-width:0.257651;stroke-opacity:1"
									id="rect31202" width="75.187386" height="21.593399" x="121.32735" y="16.744654"
									class="primary-color-circle" rx="3.9226892" ry="3.8679059" />
							</g>
						</svg>
						<i *ngIf="!loadingPreview[2]" class="fa fa-circle-check primary-color"
							[class.selected]="template==2"></i>
						<span *ngIf="loadingPreview[2]" class="selected spinner-border spinner-border-sm"></span>
					</div>
					<div class="template" (click)="selectTemplate(3)">
						<svg width="8.5in" height="11in" viewBox="0 0 215.9 279.4" version="1.1" id="svg37274"
							inkscape:version="1.1.2 (b8e25be833, 2022-02-05)" sodipodi:docname="template3.svg"
							xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
							xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
							xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
							<defs id="defs37271" />
							<g inkscape:groupmode="layer" id="layer3" inkscape:label="Capa 2">
								<rect style="fill:#1fa39b;fill-rule:evenodd;stroke-width:0.266006;fill-opacity:1"
									id="rect37370" width="139.56766" height="14.887218" x="-0.84313905" y="31.263159"
									class="primary-color" />
								<rect
									style="fill:#1fa39b;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.136855"
									id="rect37370-6" width="36.94244" height="14.887218" x="180.85744" y="31.106171"
									class="primary-color" />
								<rect
									style="fill:#1fa39b;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.184546"
									id="rect37370-6-4" width="83.970154" height="11.909775" x="133.98979" y="208.79323"
									class="secondary-color" />
								<rect style="fill:#5c5b5f;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect42860" width="193.53384" height="14.171963" x="13.026284" y="102.32051"
									class="secondary-color" />
								<rect style="fill:#eaeaeb;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect42860-7" width="193.53384" height="14.171963" x="13.02631" y="130.24861"
									class="tertiary-color" />
								<rect style="fill:#eaeaeb;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect42860-7-5" width="193.53384" height="14.171963" x="13.183297" y="157.63298"
									class="tertiary-color" />
								<rect style="fill:#eaeaeb;fill-opacity:1;fill-rule:evenodd;stroke-width:0.264583"
									id="rect42860-7-5-3" width="193.53384" height="14.171963" x="13.026314"
									y="186.40419" class="tertiary-color" />
								<path
									style="fill:none;stroke:#5c5b5f;stroke-width:0.6;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none"
									d="M 0.74436088,239.68421 H 189.06767" id="path54615"
									class="tertiary-color-circle" />
								<path
									style="fill:none;stroke:#5c5b5f;stroke-width:0.6;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
									d="M 29.402255,261.64285 H 217.72556" id="path54615-0"
									class="tertiary-color-circle" />
								<path
									style="fill:none;stroke:#5c5b5f;stroke-width:0.6;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none"
									d="M 62.898495,256.43233 V 242.66165" id="path58032"
									class="tertiary-color-circle" />
								<path
									style="fill:none;stroke:#5c5b5f;stroke-width:0.6;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
									d="M 145.73774,256.40323 V 242.63255" id="path58032-4"
									class="tertiary-color-circle" />
							</g>
						</svg>
						<i *ngIf="!loadingPreview[3]" class="fa fa-circle-check primary-color"
							[class.selected]="template==3"></i>
						<span *ngIf="loadingPreview[3]" class="selected spinner-border spinner-border-sm"></span>
					</div>
					<div class="template" id="template4-container" (click)="selectTemplate(4)">
						<i *ngIf="!loadingPreview[4]" class="fa fa-circle-check primary-color"
							[class.selected]="template==4"></i>
						<span *ngIf="loadingPreview[4]" class="selected spinner-border spinner-border-sm"></span>
					</div>
					<div class="template" id="template5-container" (click)="selectTemplate(5)">
						<i *ngIf="!loadingPreview[5]" class="fa fa-circle-check primary-color"
							[class.selected]="template==5"></i>
						<span *ngIf="loadingPreview[5]" class="selected spinner-border spinner-border-sm"></span>
					</div>
					<div class="template" id="template6-container" (click)="selectTemplate(6)">
						<i *ngIf="!loadingPreview[6]" class="fa fa-circle-check primary-color"
							[class.selected]="template==6"></i>
						<span *ngIf="loadingPreview[6]" class="selected spinner-border spinner-border-sm"></span>
					</div>
					<div class="template" id="template-7container" (click)="selectTemplate(7)">
						<img src="../../../../../assets/img/ticket.png" width="25%" alt="">
						<i *ngIf="!loadingPreview[7]" class="fa fa-circle-check primary-color"
							[class.selected]="template==7"></i>
						<span *ngIf="loadingPreview[7]" class="selected spinner-border spinner-border-sm"></span>
					</div>
				</div>
				<div class="input-group mt-2">
					<button type="button" style="width: 100%;" [disabled]="loading" class="btn btn-success"
						(click)="saveTemplate()">
						<i *ngIf="!loading" class="fa fa-save"></i>
						<span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
						GUARDAR</button>
				</div>
			</div>
			<div class="col">
				<div class="visor letter" id="visor">
					<h1 class="display-4"> <i class="fa fa-eye"></i> Acá se previsualizarán los ajustes que elijas</h1>
				</div>
			</div>
		</div>
	</div>
</div>